import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { BookOpen, UserPlus, ShareNetwork, CurrencyCircleDollar, CheckCircle, Broadcast, Sliders, VideoCamera, ArrowRight } from '@phosphor-icons/react';

const basicSteps = [
  { title: "Buat Akun Anda", desc: "Daftar gratis dalam hitungan detik. Bisa pakai email atau login langsung dengan Google.", icon: UserPlus, color: "bg-primary" },
  { title: "Atur Profil & Link", desc: "Tambahkan foto, bio, link media sosial, dan buat unit traktiran custom (misal: ☕ Kopi, 🍜 Mie Ayam).", icon: BookOpen, color: "bg-secondary" },
  { title: "Sebarkan Halaman Anda", desc: "Salin link profil (misal: traktirkan.com/u/user) dan tampilkan di bio Instagram, TikTok, atau YouTube.", icon: ShareNetwork, color: "bg-accent" },
  { title: "Terima & Cairkan Dana", desc: "Traktiran masuk otomatis. Cairkan ke rekening bank lokal kapan saja (min. Rp 10.000).", icon: CurrencyCircleDollar, color: "bg-yellow-400" },
];

const overlaySteps = [
  { n: '01', title: "Buka Dashboard → Overlay", desc: "Login ke akun kreator Anda, lalu buka tab 'Overlay' di sidebar Dashboard." },
  { n: '02', title: "Salin URL Widget", desc: "Pilih widget yang diinginkan (Alert Box, Leaderboard, dll) dan klik tombol Copy pada URL widget tersebut." },
  { n: '03', title: "Pasang di OBS", desc: "Di OBS Studio: klik Sources → + → Browser Source → Paste URL widget → Set Width: 800, Height: 600." },
  { n: '04', title: "Konfigurasi (Opsional)", desc: "Kembali ke Dashboard → atur animasi, warna, durasi alert, dan pengaturan lainnya sesuai selera." },
];

const dashboardGuide = [
  { title: "Overview", desc: "Lihat ringkasan pendapatan, total transaksi, dan statistik supporter Anda." },
  { title: "Transaksi", desc: "Riwayat lengkap semua traktiran yang masuk dengan detail pembayaran." },
  { title: "Unit Traktiran", desc: "Buat unit custom (nama, emoji, harga). Pendukung bisa memilih beli per unit atau memasukkan nominal kustom sendiri (Tulis Nominal)." },
  { title: "Goals", desc: "Buat target pendanaan dengan progress bar. Donatur bisa melihat progresnya secara langsung." },
  { title: "Penarikan", desc: "Cairkan saldo ke rekening bank. Masukkan jumlah, pilih bank, dan kirim permintaan." },
  { title: "Overlay", desc: "Kelola token overlay, copy URL widget untuk OBS, atur animasi alert, dan kontrol voting/subathon." },
  { title: "Pengaturan", desc: "Ubah profil, foto, bio, link sosmed, dan password akun Anda." },
];

export default function Guide() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 py-16">
        <div className="mb-16">
          <p className="text-xs font-black uppercase tracking-[0.3em] text-primary mb-2">Tutorial Penggunaan</p>
          <h1 className="font-display text-4xl md:text-7xl font-bold tracking-tight">PANDUAN <span className="bg-accent px-2 border-2 border-foreground shadow-brutal-sm">PENGGUNA</span></h1>
          <p className="text-lg text-foreground/70 mt-6 max-w-2xl leading-relaxed">
            Pelajari cara memulai perjalanan Anda sebagai kreator dan maksimalkan semua fitur Traktirkan termasuk overlay streaming.
          </p>
        </div>

        {/* BASIC SETUP */}
        <section className="mb-20">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-px bg-foreground/20 flex-1" />
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-foreground/40">Langkah Dasar</span>
            <div className="h-px bg-foreground/20 flex-1" />
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {basicSteps.map((s, i) => (
              <div key={i} className="border-4 border-foreground bg-white p-8 shadow-brutal-md relative overflow-hidden group">
                <div className="flex items-center justify-between mb-6">
                  <div className={`w-14 h-14 border-2 border-foreground flex items-center justify-center shadow-brutal-sm ${s.color}`}>
                    <s.icon size={28} weight="bold" />
                  </div>
                  <span className="font-display text-6xl font-black text-foreground/5 italic">0{i+1}</span>
                </div>
                <h3 className="text-2xl font-bold mb-3">{s.title}</h3>
                <p className="text-foreground/70 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* OVERLAY SETUP */}
        <section className="mb-20">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-px bg-foreground/20 flex-1" />
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-foreground/40">Pasang Overlay OBS</span>
            <div className="h-px bg-foreground/20 flex-1" />
          </div>
          <div className="border-4 border-foreground bg-foreground text-background p-8 shadow-brutal-xl mb-6 grainy">
            <div className="flex items-center gap-3 mb-4">
              <Broadcast size={32} weight="bold" className="text-primary" />
              <h2 className="font-display text-2xl md:text-3xl font-bold">Cara Pasang Overlay Streaming</h2>
            </div>
            <p className="opacity-80 text-sm mb-6">Ikuti 4 langkah berikut untuk menampilkan widget donasi di layar live stream kamu.</p>
            <div className="grid md:grid-cols-2 gap-4">
              {overlaySteps.map((s, i) => (
                <div key={i} className="border-2 border-background/20 bg-background/5 p-5">
                  <span className="font-display text-3xl font-bold text-primary">{s.n}</span>
                  <h4 className="font-bold mt-2 mb-1">{s.title}</h4>
                  <p className="text-xs opacity-70 leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="border-2 border-foreground bg-secondary/30 p-5">
            <h4 className="font-bold text-sm mb-2">💡 Tips OBS Browser Source:</h4>
            <ul className="text-xs text-foreground/70 space-y-1 list-disc ml-4">
              <li>Centang <strong>"Shutdown source when not visible"</strong> untuk menghemat resource.</li>
              <li>Centang <strong>"Refresh browser when scene becomes active"</strong> untuk auto-reconnect SSE.</li>
              <li>Untuk Alert Box: gunakan resolusi 800×600 dan posisikan di tengah layar.</li>
              <li>Untuk Ticker: gunakan resolusi 1920×100 dan posisikan di bawah layar.</li>
              <li>Jangan bagikan URL overlay ke publik (URL mengandung token rahasia).</li>
            </ul>
          </div>
        </section>

        {/* DASHBOARD GUIDE */}
        <section className="mb-20">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-px bg-foreground/20 flex-1" />
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-foreground/40">Menu Dashboard</span>
            <div className="h-px bg-foreground/20 flex-1" />
          </div>
          <div className="space-y-3">
            {dashboardGuide.map((g, i) => (
              <div key={i} className="border-2 border-foreground bg-white p-5 shadow-brutal-sm flex gap-4 items-start">
                <span className="font-display text-lg font-bold text-primary shrink-0 w-6">{i+1}.</span>
                <div>
                  <h4 className="font-bold mb-1">{g.title}</h4>
                  <p className="text-sm text-foreground/70">{g.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <div className="p-10 bg-secondary border-4 border-foreground shadow-brutal-xl">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-20 h-20 shrink-0 border-2 border-foreground bg-white flex items-center justify-center rotate-12">
              <CheckCircle size={48} weight="bold" className="text-primary" />
            </div>
            <div>
              <h4 className="text-2xl font-bold mb-2">Siap untuk mulai?</h4>
              <p className="text-foreground/70 mb-4">Sudah paham caranya? Mari buat halaman publik Anda dan mulai terima traktiran sekarang!</p>
              <div className="flex flex-wrap gap-3">
                <Link to="/register" className="inline-flex items-center gap-2 border-2 border-foreground bg-foreground text-background px-8 py-3 font-bold uppercase tracking-wide hover:bg-primary transition-colors">
                  Mulai Sekarang Gratis <ArrowRight size={16} weight="bold" />
                </Link>
                <Link to="/faq" className="inline-block border-2 border-foreground bg-white px-6 py-3 font-bold uppercase tracking-wide shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all">
                  Baca FAQ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
